import {
  ImportInfoCard,
  ImportStepper,
} from '@backstage/plugin-catalog-import';
import {
  FullPage,
  Grid,
  PageHeader,
  SvgIcon,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import React from 'react';

export const CatalogImportHomePage: React.FC = () => {
  return (
    <FullPage
      variant="card"
      HeaderComponent={() => (
        <PageHeader
          title="Start tracking your components"
          subtitle="Register an existing component"
          icon={<SvgIcon.CodeDeployed />}
        />
      )}
    >
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <ImportStepper />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ImportInfoCard />
        </Grid>
      </Grid>
    </FullPage>
  );
};
